import { render, staticRenderFns } from "./RegistraAvanzamento.vue?vue&type=template&id=2a7549ba&scoped=true&"
import script from "./RegistraAvanzamento.vue?vue&type=script&lang=js&"
export * from "./RegistraAvanzamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7549ba",
  null
  
)

export default component.exports